/*
* Consultsummary is the provides the consutlist accordion header contents
* starred, date, consult keywords, examlabels
* */
(function () {
  'use strict';
  angular.module('vcconsult')
    .component('consultsummary', {
      restrict: 'E',
      bindings: {
        consult: '<'
      },
      templateUrl: 'vcconsult/consultsummary-component.tpl.html',
      controllerAs: 'vm',
      controller: [function () {
        /* eslint "no-unused-vars": [0, {"args": "none"}] */
        let vm = this;
      }]
    });
// klammerfriedhof
}());
